import React, { cloneElement } from 'react';
import useToggle from 'react-use/lib/useToggle';
import { cn } from '../../utils/cn';
export function BranchingButton({ action, cancel, children, }) {
    const [open, toggle] = useToggle(false);
    return (React.createElement("div", { className: cn('flex flex-row items-center', 'space-x-2') }, open ? (React.createElement(React.Fragment, null,
        children,
        cloneElement(cancel, { onPress: toggle }))) : (cloneElement(action, { onPress: toggle }))));
}
